import type React from 'react';
import { cn } from '@/lib/utils';

interface SkeletonProps {
  className?: string;
  variant?: 'text' | 'circular' | 'rectangular';
  width?: string | number;
  height?: string | number;
}

const Skeleton: React.FC<SkeletonProps> = ({ className, variant = 'text', width, height }) => {
  const variantClasses = {
    text: 'rounded-md h-4',
    circular: 'rounded-full',
    rectangular: 'rounded-xl',
  };

  return (
    <div
      className={cn('animate-pulse bg-gray-200', variantClasses[variant], className)}
      style={{ width, height }}
      aria-hidden="true"
    />
  );
};

export default Skeleton;
